import React from 'react'
import MaterialSymbol from '../material-symbol'

const Lock = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="lock" {...props} />
))

Lock.displayName = 'Lock'

export default Lock
